// extracted by mini-css-extract-plugin
module.exports = {"popupFieldComponent":"Claims_popupFieldComponent__Y8Iu-","contactDetailsLink":"Claims_contactDetailsLink__VKvql"};